import React from 'react';
import { t } from 'i18next';

import styles from './styles.module.scss';
import { useGiftCardBalance } from './hooks';

function GiftCardBalance() {
  const { giftCardBalancesComponents, setUseGiftCard, useGiftCard } = useGiftCardBalance();

  return (
    <div className={styles.container}>
      <div className={styles.balanceContainer}>
        {giftCardBalancesComponents.map(({ id, description, amount, className }) => (
          <p key={id} className={className}>
            {description}
            <span>{amount}</span>
          </p>
        ))}
      </div>
      <label className={styles.label}>
        <input type="checkbox" checked={useGiftCard} onChange={setUseGiftCard} className={styles.checkbox} />
        {t('GiftCardBalance:useGiftCard')}
      </label>
    </div>
  );
}

export default GiftCardBalance;
